<template>
  <div id="app">
    <router-view></router-view>
    <Notifications/> 
  </div>
</template>

<script lang="ts">
import Notifications from "@/components/AlertNotification.vue"
import { defineComponent } from "vue";

export default defineComponent({
  name: 'App',
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Meu Ateliê',
      // all titles will be injected into this template
      titleTemplate: '%s | Gerenciador de Ateliês Dayse Costa',
  },
  data() {
    return {
      auth: false
    }
  },
  created(){
    this.auth = JSON.parse(localStorage.getItem('isAuth') || "false") === true
  },
  components: {
    Notifications,
  }
})
</script>

<style lang="scss">
#app {
  padding-bottom: 50px; /* Ajuste este valor conforme a altura do seu footer */
}
</style>
